import { FileService } from '@services/file.service';
import { Title } from '@angular/platform-browser';
import { Component, OnInit } from '@angular/core';
import { ModalController, NavParams } from '@ionic/angular';
import { EnumPageRow, IFileModel } from '@models/Common';
import { EnumGenericRoleActionAlerts } from '@pages/BasePage';
import { IConsumerChargingTemplate } from '@models/ProjectSettings';
import { environment } from '@environments/environment';

// 1 = carregar ficheiro, 2 = apenas selecionar ficheiro
export enum ENUMTypeDocument {
    Load = 1,
    Select = 2,
    Merchant = 3
}

export enum ENUMTypeDocumentVerification {
    Merchant = 1,
    Consumer = 2,
    HouseHolders = 3,
    Saft = 4,
    Charging = 5
}
@Component({
    selector: 'app-select-file-upload',
    templateUrl: './select-file-upload.component.html',
    styleUrls: ['./select-file-upload.component.scss'],
})
export class SelectFileUploadModalComponent implements OnInit {

    private onChange: Function;
    private onUpload: Function;
    private onLoad: Function;

    public File: IFileModel;
    public FileTemplate: string;
    public Modules: { Id: number, Name: string }[] = [];

    public SelectedModule: { Id: number, Name: string } = null;

    public Templates: IConsumerChargingTemplate[] = [];
    public SelectedTemplate: IConsumerChargingTemplate = null;

    public FileFormatsAllowed: string = environment.FileImports.SpreadsheetFormats.join(',');
    public Title: string = '';

    public Type: ENUMTypeDocument = ENUMTypeDocument.Load;

    public ENUMTypeDocument = ENUMTypeDocument;

    public ViewDocument: boolean = false;

    public ExcelData: any[][] = [];
    public XMLData: any = null;
    public RootKey: string = ''; // ← preenchido dinamicamente após parse

    public Errors: string;

    public ValueErrors: { row: number; col: number; message: string }[] = [];
    public CellErrorsMap: Map<string, string> = new Map();
    public ErrorRowIndexes: Set<number> = new Set();
    public ShowOnlyErrors: boolean = false;

    public ValueWarnings: { row: number; col: number; message: string }[] = [];
    public CellWarningsMap: Map<string, string> = new Map();

    public TypeDocumentVerification: ENUMTypeDocumentVerification;

    public ProcessList: any[] = [];
    public PagedProcessList: any[] = [];
    public HasOnLoad: boolean = false;

    public PageNumber: number = 1;
    public PageRows: number = EnumPageRow.R25;

    constructor(
        private NavParams: NavParams,
        private ModalController: ModalController,
        private FileService: FileService
    ) {

        this.Title = this.NavParams?.get('title') || null;
        this.onChange = this.NavParams?.get('onChange') || null;
        this.onUpload = this.NavParams?.get('onUpload') || null;
        this.onLoad = this.NavParams?.get('onLoad') || null;
        this.HasOnLoad = !!this.onLoad;
        this.FileTemplate = this.NavParams?.get('fileTemplate') || '';
        this.Type = this.NavParams?.get('type') || this.Type;
        this.TypeDocumentVerification = this.NavParams?.get('typeVerification') || this.TypeDocumentVerification;
        this.ViewDocument = this.NavParams?.get('viewDocument') || this.ViewDocument;
        this.Modules = this.NavParams?.get('modules') || [];

        this.FileFormatsAllowed = this.NavParams?.get('formatsAllowed') || this.FileFormatsAllowed;

        this.Templates = (this.NavParams?.get('templates') || []).filter(it => it?.Enable);

        console.log(this.Modules);

        if (this.Modules?.length == 1)
            this.SelectedModule = this.Modules[0];

        if (this.Templates?.length > 0) {
            this.SelectedTemplate = this.Templates[0];
            this.FileTemplate = this.SelectedTemplate.Path;
            this.TypeDocumentVerification = this.SelectedTemplate.Type;
        }

    }

    async ngOnInit() {

        if (this.onLoad)
            this.ProcessList = await this.onLoad();

        this.ApplyPagination();
    }

    async OnRefresh(ev?: any) {

        if (this.onLoad)
            this.ProcessList = await this.onLoad();

        this.PageNumber = 1;
        this.ApplyPagination();
    }

    OnChangePage(ev: { page: number, itemsPerPage: number }) {

        this.PageNumber = ev.page;
        this.PageRows = ev.itemsPerPage;

        this.ApplyPagination();
    }

    private ApplyPagination() {

        const start = (this.PageNumber - 1) * this.PageRows;

        this.PagedProcessList = (this.ProcessList || []).slice(start, start + this.PageRows);
    }

    /**
     * 
     * @param file 
     * @returns 
     */
    async OnChangeFile(file: any) {

        console.log(file);

        if (file?.files?.length == 0) return;

        if (this.onChange)
            this.File = await this.onChange(file);

        this.XMLData = null;
        this.ExcelData = [];
        this.ValueErrors = [];
        this.CellErrorsMap = new Map();
        this.ErrorRowIndexes = new Set();
        this.ValueWarnings = [];
        this.CellWarningsMap = new Map();
        this.ShowOnlyErrors = false;

        if (this.File && this.ViewDocument) {

            if (this.FileFormatsAllowed?.includes('xls')) {
                this.ExcelData = await this.FileService.ReadExcelFile(file?.files[0]);

                if (this.ExcelData?.length > 2) {

                    let errors;

                    switch (this.TypeDocumentVerification) {
                        case ENUMTypeDocumentVerification.Merchant:

                            errors = this.FileService.ValidateStructureForMerchantFile(this.ExcelData);

                            console.log(errors);

                            if (errors?.isValid !== false) {

                                this.ValueErrors = this.FileService.ValidateMerchantFileValues(this.ExcelData);
                                this.CellErrorsMap = new Map(this.ValueErrors.map(it => [`${it.row}_${it.col}`, it.message]));
                                this.ErrorRowIndexes = new Set(this.ValueErrors.map(it => it.row));
                            }

                            break;
                        case ENUMTypeDocumentVerification.Consumer:

                            errors = this.FileService.ValidateStructureForConsumerFile(this.ExcelData);

                            console.log(errors);

                            if (errors?.isValid !== false) {

                                const result = this.FileService.ValidateConsumerFileValues(this.ExcelData);
                                this.ValueErrors = result.errors;
                                this.ValueWarnings = result.warnings;
                                this.CellErrorsMap = new Map(this.ValueErrors.map(it => [`${it.row}_${it.col}`, it.message]));
                                this.ErrorRowIndexes = new Set(this.ValueErrors.map(it => it.row));
                                this.CellWarningsMap = new Map(this.ValueWarnings.map(it => [`${it.row}_${it.col}`, it.message]));
                            }

                            break;
                        case ENUMTypeDocumentVerification.Charging:

                            errors = this.FileService.ValidateStructureForCampaignChargingFile(this.ExcelData);

                            console.log(errors);

                            break;
                        case ENUMTypeDocumentVerification.HouseHolders:

                            errors = this.FileService.ValidateStructureForConsumerHouseHoldersFile(this.ExcelData);

                            console.log(errors);

                            if (errors?.isValid !== false) {

                                const result = this.FileService.ValidateConsumerHouseHoldersFileValues(this.ExcelData, false);
                                this.ValueErrors = result.errors;
                                this.ValueWarnings = result.warnings;
                                this.CellErrorsMap = new Map(this.ValueErrors.map(it => [`${it.row}_${it.col}`, it.message]));
                                this.ErrorRowIndexes = new Set(this.ValueErrors.map(it => it.row));
                                this.CellWarningsMap = new Map(this.ValueWarnings.map(it => [`${it.row}_${it.col}`, it.message]));
                            }

                            break;
                        default:
                            break;
                    }

                    if (errors?.isValid === false) {
                        this.ExcelData = [];
                        this.Errors = "O ficheiro não é válido, utilize a estrutura do \"ficheiro template\".";
                        this.File = null;
                        return
                    }

                }
            }
            else if (this.FileFormatsAllowed?.includes('xml')) {

                const data = await this.FileService.ReadXMLFile(file?.files[0]);

                debugger
                const keys = Object.keys(data);
                this.RootKey = keys.length > 0 ? keys[0] : 'Desconhecido';
                this.XMLData = data; //[this.RootKey]; // ou data, dependendo do que quer exibir

            }
            else {

            }

        }

    }

    /**
     * 
     */
    async OnUploadFile() {

        console.log(this.SelectedModule);


        if (this.onChange) {
            const response = await this.onUpload(this.File, this.SelectedModule?.Id, this.SelectedTemplate);

            if (response)
                this.ModalController.dismiss(null, EnumGenericRoleActionAlerts.Close);

        }
    }

    ChangeModule(e) {
        console.log(e);
        this.SelectedModule = e?.detail?.value || null;
    }

    ChangeTemplate(e) {
        this.SelectedTemplate = e?.detail?.value || null;
        this.FileTemplate = this.SelectedTemplate?.Path || '';
        this.TypeDocumentVerification = this.SelectedTemplate?.Type;

        this.File = null;
        this.ExcelData = [];
        this.XMLData = null;
        this.Errors = null;
        this.ValueErrors = [];
        this.CellErrorsMap = new Map();
        this.ErrorRowIndexes = new Set();
        this.ValueWarnings = [];
        this.CellWarningsMap = new Map();
        this.ShowOnlyErrors = false;
    }

    Close() {
        // using the injected ModalController this page
        // can "dismiss" itself and optionally pass back data
        this.ModalController.dismiss(null, EnumGenericRoleActionAlerts.Close);
    }


    GetDataRows(): { Cells: any[]; RowIndex: number }[] {
        // slice(1) remove a primeira linha (headers); RowIndex é o índice real em ExcelData (usado nas chaves de CellErrorsMap)
        const rows = this.ExcelData.slice(1).map((cells, i) => ({ Cells: cells, RowIndex: i + 1 }));
        return this.ShowOnlyErrors ? rows.filter(row => this.ErrorRowIndexes.has(row.RowIndex)) : rows;
    }

    TrackByRowIndex(index: number, row: { RowIndex: number }) {
        return row?.RowIndex ?? index;
    }

    ToggleShowOnlyErrors() {
        this.ShowOnlyErrors = !this.ShowOnlyErrors;
    }

    HasCellError(rowIndex: number, colIndex: number): boolean {
        return this.CellErrorsMap.has(`${rowIndex}_${colIndex}`);
    }

    GetCellError(rowIndex: number, colIndex: number): string {
        return this.CellErrorsMap.get(`${rowIndex}_${colIndex}`) || '';
    }

    HasCellWarning(rowIndex: number, colIndex: number): boolean {
        return this.CellWarningsMap.has(`${rowIndex}_${colIndex}`);
    }

    GetCellWarning(rowIndex: number, colIndex: number): string {
        return this.CellWarningsMap.get(`${rowIndex}_${colIndex}`) || '';
    }

    async OnView(ev: any, item) {

        ev?.preventDefault();
        ev?.stopPropagation();

        if (!item?.OutputFile?.Path) return;

        window.open(item?.OutputFile?.Path, '_blank');
    }
}
